export const ROLES = {
  ADMIN: 'Admin',
  ADMIN_LEADERBOARD: 'Admin Leaderboard',
  DEALER: 'Dealer',
  WAITRESS: 'Server/waitress',
  CASHIER: 'Cashier',
  BARTENDER: 'Bartender',
  HOST: 'Host',
  FLOOR_SUPERVISOR: 'Floor Supervisor',
  COOK: 'Cook',
  JANITOR: 'Custodian/Janitor',
};

export const ADMIN_LEADERBOARD_ALLOWED_PATHS = ['/tournament-leaderboard'];

/** Paths reserved for Admin only */
export const MANAGEMENT_ONLY_PATHS = [
  '/',
  '/user-management',
  '/employee-management',
  '/token-reserves',
  '/starting-closing-tables-time',
];

export const MANAGEMENT_ONLY_PREFIXES = ['/dashboard/payroll'];

/** Paths strictly reserved for Admin only */
export const ADMIN_ONLY_PATHS = [
  '/tax-management',
];


export const isAdminOnlyPath = (pathname) => {
  return ADMIN_ONLY_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
};

/** Default landing for Cashier / Floor Supervisor */
export const TRANSACTION_HOME_PATH = '/promos';


const normalizeRole = (role) => String(role || "").trim().toLowerCase();

export const isAdminLeaderboardRole = (role) => normalizeRole(role) === 'admin leaderboard';

export const isAdminRole = (role) => {
  const norm = normalizeRole(role);
  return norm === 'admin' || norm === 'management';
};

export const isManagementRole = (role) => isAdminRole(role);

/** Allowed to view tip change activity logs: Admin, Admin Leaderboard */
export const isActivityLogViewerRole = (role) => {
  const norm = normalizeRole(role);
  return (
    norm === 'admin' ||
    norm === 'admin leaderboard'
  );
};

export const isFloorRole = (role) => {
  const norm = normalizeRole(role);
  return norm === "floor supervisor" || norm === "floorsupervisor" || norm === "floor";
};

export const isCashierOrFloorSupervisor = (role) => {
  const norm = normalizeRole(role);
  return norm === "cashier" || isFloorRole(role);
};

export const isTransactionAccessRole = (role) =>
  isManagementRole(role) || isCashierOrFloorSupervisor(role);

export const isEplPlayersAccessRole = (role) =>
  isManagementRole(role) || isCashierOrFloorSupervisor(role);

/** Send and monitor SMS. Does not include payroll, user management, or other management tools. */
export const isSmsAccessRole = (role) => isEplPlayersAccessRole(role);

export const isManagementOnlyPath = (pathname) => {
  if (MANAGEMENT_ONLY_PATHS.includes(pathname)) return true;
  return MANAGEMENT_ONLY_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
};

/**
 * Checks if a role name is a core system role (non-editable, non-deletable)
 */
export const isCoreSystemRole = (role) => {
  const norm = normalizeRole(role);
  return (
    norm === 'admin' ||
    norm === 'admin leaderboard' ||
    norm === 'dealer' ||
    norm === 'server/waitress' ||
    norm === 'waitress' ||
    norm === 'server' ||
    norm === 'cashier' ||
    norm === 'bartender' ||
    norm === 'host' ||
    norm === 'hosts' ||
    norm === 'floor supervisor' ||
    norm === 'floorsupervisor' ||
    norm === 'floor' ||
    norm === 'cook' ||
    norm === 'cooks' ||
    norm === 'custodian/janitor' ||
    norm === 'janitor' ||
    norm === 'custodian'
  );
};

/**
 * Index order for core system roles. Returns 999 for custom/added roles.
 */
export const getCoreRoleIndex = (roleName) => {
  const norm = normalizeRole(roleName);
  if (norm === 'admin') return 0;
  if (norm === 'admin leaderboard') return 1;
  if (norm === 'dealer') return 2;
  if (norm === 'server/waitress' || norm === 'waitress' || norm === 'server') return 3;
  if (norm === 'cashier') return 4;
  if (norm === 'bartender') return 5;
  if (norm === 'host' || norm === 'hosts') return 6;
  if (norm === 'floor supervisor' || norm === 'floorsupervisor' || norm === 'floor') return 7;
  if (norm === 'cook' || norm === 'cooks') return 8;
  if (norm === 'custodian/janitor' || norm === 'janitor' || norm === 'custodian') return 9;
  return 999;
};
